import React, {Component} from 'react';

class Jokes extends Component{

    state =  {joke:{}}

    componentDidMount(){
        fetch('https:official-joke-api.appspot.com/random_joke')
        .then(responce => responce.json())
        .then(randomee => this.setState({joke:randomee}));
    }

    render(){

        const {setup,punchline} = this.state.joke;
        console.log('joke state', this.state);
        return(
            <div>
                <p style={{fontSize:"12px"}}>{setup} <i>{punchline}</i></p>
            </div>
        )
    }
}

export default Jokes;